import React, { useState, useEffect } from 'react';
import { 
  Container, Row, Col, Card, Button, Spinner,
  CardHeader, CardBody, Label, Input, Form, Alert
} from '../../Components/Common/Tailwind';
import { packageService, getUserOrdersByDate, getUserOrdersByOrderId, getOrderListByPage, processOrderFreeBooking } from '../../api/services/package.service';
import { authService, changeCancelableUserConfirm } from '../../api/services/auth.service';
import { userService } from '../../api/services/user.service';
import './ApiTester.css';
import ReactJson from 'react-json-view';

const formatDateToString = (date) => {
  const d = new Date(date);
  return d.toISOString().split('T')[0];
};

const getTodayFormatted = () => {
  return formatDateToString(new Date());
};

const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const ApiTester = () => {
  const [selectedService, setSelectedService] = useState('packageService');
  const [selectedEndpoint, setSelectedEndpoint] = useState('');
  const [params, setParams] = useState({});
  const [paramsConfig, setParamsConfig] = useState([]);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [requestDetails, setRequestDetails] = useState(null);
  const [copySuccess, setCopySuccess] = useState('');
  const [showRawResponse, setShowRawResponse] = useState(false);
  const [showFullResponse, setShowFullResponse] = useState(false);
  const [showOnlyData, setShowOnlyData] = useState(false);
  const [savedParamSets, setSavedParamSets] = useState({});
  const [savedParamName, setSavedParamName] = useState('');

  const services = {
    packageService: {
      name: 'Package Service',
      service: packageService,
      endpoints: [
        { 
          name: 'getPackageItemById', 
          method: 'GET',
          params: [
            { name: 'id', type: 'string', required: true }
          ]
        },
        { 
          name: 'getPackageItemsByDate', 
          method: 'GET',
          params: [
            { name: 'startDate', type: 'string', required: true },
            { name: 'id', type: 'string', required: true }
          ]
        },
        { 
          name: 'getLodgePackageDetail', 
          method: 'GET',
          params: [
            { name: 'id', type: 'string', required: true },
            { name: 'startDate', type: 'string', required: true },
            { name: 'endDate', type: 'string', required: true }
          ]
        },
        { 
          name: 'getPackagesByDateRange',
          method: 'GET',
          params: [
            { name: 'startDate', type: 'string', required: true },
            { name: 'endDate', type: 'string', required: true },
            { name: 'subdomain', type: 'string', required: true },
            { name: 'membership_product_id', type: 'string', required: false }
          ]
        },
        { 
          name: 'getLodgePackagePrice',
          method: 'GET',
          params: [
            { name: 'id', type: 'string', required: true },
            { name: 'startDate', type: 'string', required: true },
            { name: 'endDate', type: 'string', required: true },
            { name: 'spot_str', type: 'string', required: true }
          ]
        },
        { 
          name: 'getReservationById',
          method: 'GET',
          params: [
            { name: 'id', type: 'string', required: true }
          ]
        },
        { 
          name: 'getOptionListByReservId',
          method: 'GET',
          params: [
            { name: 'reservId', type: 'string', required: true }
          ]
        },
        { 
          name: 'getOptionListByOrderId',
          method: 'GET',
          params: [
            { name: 'orderId', type: 'string', required: true }
          ]
        },
        { 
          name: 'inviteUserForReservation',
          method: 'POST',
          params: [
            { name: 'reservId', type: 'number', required: true },
            { name: 'phoneNum', type: 'string', required: true }
          ]
        },
        { 
          name: 'giftReservationToKakaoFriend',
          method: 'POST',
          params: [
            { name: 'reservId', type: 'number', required: true },
            { name: 'kakaoId', type: 'string', required: true }
          ]
        },
        { 
          name: 'giftReservationByUrl',
          method: 'POST',
          params: [
            { name: 'reservId', type: 'number', required: true }
          ]
        },
        {
          name: 'useReservationGift',
          method: 'POST',
          params: [
            { name: 'reservId', type: 'number', required: true }
          ]
        },
        {
          name: 'getReservationQRCode',
          method: 'GET',
          params: [
            { name: 'reservId', type: 'number', required: true }
          ]
        },
        {
          name: 'getReservationGifts',
          method: 'GET',
          params: [
            { name: 'phone', type: 'string', required: true },
            { name: 'date', type: 'string', required: false }
          ]
        },
        {
          name: 'putReceiveReservationById',
          method: 'PUT',
          params: [
            { name: 'giftId', type: 'number', required: true }
          ]
        },
        {
          name: 'deleteReservationGiftById',
          method: 'DELETE',
          params: [
            { name: 'reservId', type: 'number', required: true }
          ]
        }
      ]
    },
    userOrders: {
      name: 'User Orders',
      service: null,
      endpoints: [
        {
          name: 'getUserOrdersByDate',
          method: 'GET',
          func: getUserOrdersByDate,
          params: [
            { name: 'date', type: 'string', required: true }
          ]
        },
        {
          name: 'getUserOrdersByOrderId',
          method: 'GET',
          func: getUserOrdersByOrderId,
          params: [
            { name: 'orderId', type: 'string', required: true }
          ]
        },
        {
          name: 'getOrderListByPage',
          method: 'GET',
          func: getOrderListByPage,
          params: [
            { name: 'page', type: 'number', required: true },
            { name: 'queryString', type: 'string', required: false }
          ]
        },
        {
          name: 'processOrderFreeBooking',
          method: 'POST',
          func: processOrderFreeBooking,
          params: [
            { name: 'orderId', type: 'string', required: true },
            { name: 'amount', type: 'string', required: true }
          ]
        }
      ]
    },
    authService: {
      name: 'Authentication Service',
      service: authService,
      endpoints: [
        {
          name: 'postPhoneAuth',
          method: 'POST',
          params: [
            { name: 'phoneNum', type: 'string', required: true }
          ]
        },
        {
          name: 'postPhoneLogin',
          method: 'POST',
          params: [
            { name: 'phoneNum', type: 'string', required: true }
          ]
        },
        {
          name: 'postKakaoToken',
          method: 'POST',
          params: [
            { name: 'kakaoToken', type: 'string', required: true }
          ]
        },
        {
          name: 'exchangeKakaoCode',
          method: 'POST',
          params: [
            { name: 'code', type: 'string', required: true },
            { name: 'restApiKey', type: 'string', required: true }
          ]
        },
        {
          name: 'adminLogin',
          method: 'POST',
          params: [
            { name: 'phone_num', type: 'string', required: true },
            { name: 'password', type: 'string', required: true }
          ]
        },
        {
          name: 'refreshToken',
          method: 'POST',
          params: []
        }
      ]
    },
    userService: {
      name: 'User Service',
      service: userService,
      endpoints: [
        {
          name: 'getUserInfo',
          method: 'GET',
          params: []
        },
        {
          name: 'getUserById',
          method: 'GET',
          params: [
            { name: 'userId', type: 'number', required: true },
            { name: 'pathname', type: 'string', required: false }
          ]
        },
        {
          name: 'getCancelableUsers',
          method: 'GET',
          params: []
        },
        {
          name: 'getKakaoChannels',
          method: 'GET',
          params: []
        },
        {
          name: 'putSetUserName',
          method: 'PUT',
          params: [
            { name: 'username', type: 'string', required: true },
            { name: 'phone_num', type: 'number', required: false }
          ]
        }
      ]
    },
    otherFunctions: {
      name: 'Other Functions',
      service: null,
      endpoints: [
        {
          name: 'changeCancelableUserConfirm',
          method: 'PUT',
          func: changeCancelableUserConfirm,
          params: [
            { name: 'isConfirm', type: 'boolean', required: true }
          ]
        }
      ]
    }
  };

  useEffect(() => {
    if (selectedEndpoint) {
      const serviceObj = services[selectedService];
      const endpoint = serviceObj.endpoints.find(ep => ep.name === selectedEndpoint);
      
      if (endpoint) {
        setParamsConfig(endpoint.params);
        
        const initialParams = {};
        endpoint.params.forEach(param => {
          initialParams[param.name] = '';
        });
        setParams(initialParams);
      }
    } else {
      setParamsConfig([]);
      setParams({});
    }
  }, [selectedEndpoint, selectedService]);

  const handleServiceChange = (e) => {
    setSelectedService(e.target.value);
    setSelectedEndpoint('');
    setParams({});
    setParamsConfig([]);
    setResult(null);
    setError(null);
  };

  const handleEndpointChange = (e) => {
    setSelectedEndpoint(e.target.value);
    setResult(null);
    setError(null);
  };

  const handleParamChange = (paramName, value) => {
    setParams(prevParams => ({
      ...prevParams,
      [paramName]: value
    }));
  };

  const formatParamValue = (param, value) => {
    if (value === '') return undefined;
    
    switch (param.type) {
      case 'number':
        return Number(value);
      case 'boolean':
        return value === 'true';
      case 'object':
        try {
          return JSON.parse(value);
        } catch (e) {
          return value;
        }
      default:
        return value;
    }
  };

  const executeRequest = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    setRequestDetails(null);
    
    try {
      const serviceObj = services[selectedService];
      const endpoint = serviceObj.endpoints.find(ep => ep.name === selectedEndpoint);
      
      if (!endpoint) {
        throw new Error('Endpoint not found');
      }
      
      const formattedParams = {};
      Object.keys(params).forEach(key => {
        const param = endpoint.params.find(p => p.name === key);
        if (param && params[key] !== '') {
          formattedParams[key] = formatParamValue(param, params[key]);
        }
      });
      
      const orderedParams = endpoint.params.map(param => 
        formattedParams[param.name]
      ).filter(p => p !== undefined);
      
      let baseUrl = '';
      if (selectedService.includes('package')) {
        baseUrl = '/api/package/';
      } else if (selectedService.includes('auth')) {
        baseUrl = '/api/auth/';
      } else if (selectedService.includes('user')) {
        baseUrl = '/api/user/';
      } else {
        baseUrl = '/api/';
      }
      
      const fullAddress = `${baseUrl}${selectedEndpoint}`;
      
      setRequestDetails({
        service: selectedService,
        endpoint: selectedEndpoint,
        method: endpoint.method,
        fullAddress: fullAddress,
        params: orderedParams.length > 0 ? orderedParams : null
      });
      
      let response;
      
      if (serviceObj.service) {
        const method = serviceObj.service[endpoint.name];
        
        if (typeof method !== 'function') {
          throw new Error(`Method ${endpoint.name} not found in service ${selectedService}`);
        }
        
        response = await method(...orderedParams);
      } else if (endpoint.func) {
        response = await endpoint.func(...orderedParams);
      } else {
        throw new Error('No executable function found');
      }
      
      setResult(response);
    } catch (err) {
      console.error('API request failed:', err);
      setError({
        message: err.message,
        details: err.response ? {
          status: err.response.status,
          data: err.response.data
        } : null
      });
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = () => {
    try {
      const resultString = JSON.stringify(result, null, 2);
      navigator.clipboard.writeText(resultString);
      setCopySuccess('Copied!');
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      setCopySuccess('Failed to copy');
      setTimeout(() => setCopySuccess(''), 2000);
    }
  };

  const resetResults = () => {
    setResult(null);
    setError(null);
    setRequestDetails(null);
  };

  useEffect(() => {
    const savedSets = localStorage.getItem('apiTesterSavedParams');
    if (savedSets) {
      try {
        setSavedParamSets(JSON.parse(savedSets));
      } catch (e) {
        console.error('Failed to parse saved parameter sets', e);
      }
    }
  }, []);

  const saveCurrentParams = () => {
    if (!savedParamName.trim() || !selectedEndpoint) return;
    
    const newSavedSets = {
      ...savedParamSets,
      [savedParamName]: {
        service: selectedService,
        endpoint: selectedEndpoint,
        params: { ...params }
      }
    };
    
    setSavedParamSets(newSavedSets);
    localStorage.setItem('apiTesterSavedParams', JSON.stringify(newSavedSets));
    setSavedParamName('');
  };

  const loadSavedParams = (name) => {
    const savedSet = savedParamSets[name];
    if (savedSet) {
      setSelectedService(savedSet.service);
      setTimeout(() => {
        setSelectedEndpoint(savedSet.endpoint);
        setParams(savedSet.params);
      }, 0);
    }
  };

  const deleteSavedParamSet = (name, e) => {
    e.stopPropagation();
    const { [name]: _, ...rest } = savedParamSets;
    setSavedParamSets(rest);
    localStorage.setItem('apiTesterSavedParams', JSON.stringify(rest));
  };

  return (
    <Container className="api-tester-container text-gray-900 dark:text-white">
      <h1 className="text-center mb-4 text-gray-900 dark:text-white">API Tester</h1>
      <p className="text-center text-gray-600 dark:text-gray-400 mb-4">Test your API endpoints with this interactive tester</p>
      
      <Row>
        <Col xs={12} lg={5}>
          <Card className="mb-4">
            <CardHeader><h4 className="mb-0 text-gray-900 dark:text-white">Request</h4></CardHeader>
            <CardBody>
              <Form>
                <div className="mb-4">
                  <Label>Service</Label>
                  <Input 
                    type="select"
                    value={selectedService}
                    onChange={handleServiceChange}
                  >
                    {Object.keys(services).map(serviceKey => (
                      <option key={serviceKey} value={serviceKey}>
                        {services[serviceKey].name}
                      </option>
                    ))}
                  </Input>
                </div>
                
                <div className="mb-4">
                  <Label>Endpoint</Label>
                  <Input 
                    type="select"
                    value={selectedEndpoint}
                    onChange={handleEndpointChange}
                    disabled={!selectedService}
                  >
                    <option value="">Select an endpoint</option>
                    {selectedService && services[selectedService].endpoints.map(endpoint => (
                      <option key={endpoint.name} value={endpoint.name}>
                        {endpoint.name} ({endpoint.method})
                      </option>
                    ))}
                  </Input>
                </div>
                
                {paramsConfig.length > 0 && (
                  <div className="mt-4 p-3 border border-gray-300 rounded-lg">
                    <h5 className="mb-3 text-gray-900 dark:text-white font-semibold">Parameters</h5>
                    {paramsConfig.map(param => (
                      <div className="mb-4" key={param.name}>
                        <Label>
                          {param.name}
                          {param.required && <span className="text-red-600 ml-1">*</span>}
                          <small className="text-gray-600 dark:text-gray-400 ml-2">({param.type})</small>
                        </Label>
                        <Input
                          type={param.type === 'number' ? 'number' : 'text'}
                          value={params[param.name] || ''}
                          onChange={(e) => handleParamChange(param.name, e.target.value)}
                          placeholder={`Enter ${param.name}`}
                          className="mt-1"
                        />
                        {param.name.toLowerCase().includes('subdomain') && (
                          <div className="mt-2">
                            <small className="text-gray-600 dark:text-gray-400 block mb-1">Common subdomains:</small>
                            <div className="flex gap-2 flex-wrap">
                              {['test', 'dev', 'amazingpark'].map(domain => (
                                <Button 
                                  key={domain}
                                  size="sm" 
                                  variant="secondary"
                                  onClick={() => handleParamChange(param.name, domain)}
                                  className="text-gray-700 dark:text-gray-300"
                                >
                                  {domain}
                                </Button>
                              ))}
                            </div>
                          </div>
                        )}
                        {(param.name.toLowerCase().includes('date') || 
                         param.name.toLowerCase().includes('start') ||
                         param.name.toLowerCase().includes('end')) && (
                          <div className="mt-2 flex gap-2">
                            <Button 
                              size="sm" 
                              variant="secondary"
                              onClick={() => handleParamChange(param.name, getTodayFormatted())}
                              className="text-gray-700 dark:text-gray-300"
                            >
                              Today
                            </Button>
                            <Button 
                              size="sm" 
                              variant="secondary"
                              onClick={() => handleParamChange(param.name, formatDateToString(addDays(new Date(), 1)))}
                              className="text-gray-700 dark:text-gray-300"
                            >
                              Tomorrow
                            </Button>
                            <Button 
                              size="sm" 
                              variant="secondary"
                              onClick={() => handleParamChange(param.name, formatDateToString(addDays(new Date(), 7)))}
                              className="text-gray-700 dark:text-gray-300"
                            >
                              Next Week
                            </Button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                
                <Button 
                  variant="primary" 
                  onClick={executeRequest}
                  disabled={loading || !selectedEndpoint}
                  className="mt-4 w-full sm:w-auto"
                >
                  {loading ? (
                    <>
                      <Spinner size="sm" />
                      <span className="ml-2">Loading...</span>
                    </>
                  ) : 'Send Request'}
                </Button>

                {selectedEndpoint && (
                  <div className="mt-4 p-3 border border-gray-300 rounded-lg">
                    <h5 className="mb-3 text-gray-900 dark:text-white font-semibold">Save Parameters</h5>
                    <div className="flex gap-2">
                      <Input
                        type="text"
                        placeholder="Enter a name for this parameter set"
                        value={savedParamName}
                        onChange={(e) => setSavedParamName(e.target.value)}
                        className="flex-1"
                      />
                      <Button 
                        variant="secondary"
                        onClick={saveCurrentParams}
                        disabled={!savedParamName.trim()}
                        className="text-[var(--color-primary)] dark:text-[var(--color-primary)] btn-outline-primary"
                      >
                        Save
                      </Button>
                    </div>
                    
                    {Object.keys(savedParamSets).length > 0 && (
                      <div className="mt-3">
                        <h6 className="mb-2 font-semibold text-gray-900 dark:text-white">Saved Sets:</h6>
                        <div className="space-y-2">
                          {Object.keys(savedParamSets).map(name => (
                            <div 
                              key={name}
                              className="p-3 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 cursor-pointer transition-colors flex justify-between items-center"
                              onClick={() => loadSavedParams(name)}
                            >
                              <span className="text-sm font-medium text-gray-900 dark:text-white">{name}</span>
                              <Button
                                variant="secondary"
                                size="sm"
                                onClick={(e) => deleteSavedParamSet(name, e)}
                                className="ml-2 text-red-600 dark:text-red-400 hover:text-white btn-outline-danger"
                              >
                                &times;
                              </Button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </Form>
            </CardBody>
          </Card>
        </Col>
        
        <Col xs={12} lg={7}>
          <Card>
            <CardHeader className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
              <h4 className="mb-0 text-gray-900 dark:text-white">Response</h4>
              <div className="flex gap-1 flex-wrap w-full sm:w-auto">
                {result && (
                  <>
                    <Button 
                      variant="secondary"
                      size="sm"
                      onClick={() => {
                        setShowRawResponse(false);
                        setShowOnlyData(false);
                        setShowFullResponse(!showFullResponse);
                      }}
                      className={`text-gray-700 dark:text-gray-300 ${!showRawResponse && !showOnlyData && showFullResponse ? 'bg-blue-600 text-white border-blue-600' : ''}`}
                    >
                      {showFullResponse ? 'Hide Full Response' : 'Show Full Response'}
                    </Button>
                    <Button 
                      variant="secondary"
                      size="sm"
                      onClick={() => {
                        setShowRawResponse(!showRawResponse);
                        setShowOnlyData(false);
                      }}
                      className={`text-gray-700 dark:text-gray-300 ${showRawResponse ? 'bg-blue-600 text-white border-blue-600' : ''}`}
                    >
                      {showRawResponse ? 'Show Parsed' : 'Show Raw'}
                    </Button>
                    <Button 
                      variant="secondary"
                      size="sm"
                      onClick={() => {
                        setShowOnlyData(!showOnlyData);
                        setShowRawResponse(false);
                      }}
                      className={`text-gray-700 dark:text-gray-300 ${showOnlyData ? 'bg-blue-600 text-white border-blue-600' : ''}`}
                    >
                      Show Only Data
                    </Button>
                    <Button 
                      variant="secondary"
                      size="sm"
                      onClick={copyToClipboard}
                      disabled={!result}
                      className="text-gray-700 dark:text-gray-300"
                    >
                      {copySuccess || 'Copy to Clipboard'}
                    </Button>
                  </>
                )}
                {(result || error || requestDetails) && (
                  <Button 
                    variant="secondary"
                    size="sm"
                    onClick={resetResults}
                    className="ml-2 text-gray-700 dark:text-gray-300"
                  >
                    Clear Results
                  </Button>
                )}
              </div>
            </CardHeader>
            <CardBody className="max-h-[70vh] overflow-y-auto">
              {requestDetails && (
                <div className="request-details mb-4 p-3 border border-gray-300 rounded-lg bg-blue-50 dark:bg-blue-900/20 dark:border-gray-700">
                  <h5 className="mb-2 font-semibold text-gray-900 dark:text-white">Request</h5>
                  <p className="mb-1 text-gray-800 dark:text-gray-200"><strong>Service:</strong> {requestDetails.service}</p>
                  <p className="mb-1 text-gray-800 dark:text-gray-200"><strong>Endpoint:</strong> {requestDetails.endpoint}</p>
                  <p className="mb-1 text-gray-800 dark:text-gray-200"><strong>Method:</strong> {requestDetails.method}</p>
                  <p className="mb-1 text-gray-800 dark:text-gray-200"><strong>Full Address:</strong> {requestDetails.fullAddress}</p>
                  {requestDetails.params && (
                    <div className="mt-2">
                      <p className="mb-1 text-gray-800 dark:text-gray-200"><strong>Parameters:</strong></p>
                      <ReactJson src={requestDetails.params} name={null} collapsed={2} displayDataTypes={false} />
                    </div>
                  )}
                </div>
              )}
            
              {loading ? (
                <div className="text-center p-5">
                  <Spinner size="md" />
                  <span className="sr-only">Loading...</span>
                </div>
              ) : error ? (
                <div className="text-red-600 dark:text-red-400">
                  <h5 className="font-semibold mb-2">Error</h5>
                  <p className="mb-2">{error.message}</p>
                  {error.details && (
                    <ReactJson src={error.details} name={null} collapsed={2} />
                  )}
                </div>
              ) : result ? (
                <>
                  {!showFullResponse && (
                    <Alert color="info" className="my-2">
                      Click "Show Full Response" to view all response details.
                    </Alert>
                  )}
                  
                  {showFullResponse && (
                    showRawResponse ? (
                      <pre className="json-response">
                        {JSON.stringify(result, null, 2)}
                      </pre>
                    ) : (
                      <ReactJson 
                        src={result} 
                        name={null} 
                        collapsed={1} 
                        theme="rjv-default"
                        displayDataTypes={false}
                        enableClipboard={false}
                      />
                    )
                  )}
                  
                  {showOnlyData && (
                    <div className="p-3 border border-gray-300 rounded-lg">
                      <h5 className="mb-2 font-semibold text-gray-900 dark:text-white">Data Only View</h5>
                      <ReactJson 
                        src={result?.data || result?.result || result} 
                        name={null} 
                        collapsed={2} 
                        theme="rjv-default"
                        displayDataTypes={false}
                        enableClipboard={false}
                      />
                    </div>
                  )}
                </>
              ) : (
                <div className="text-center text-gray-600 dark:text-gray-400 p-5">
                  <p>No data to display. Select an endpoint and send a request.</p>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ApiTester;
